import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import en from 'vuetify/es5/locale/en'
import ru from 'vuetify/es5/locale/ru'
import ua from 'vuetify/es5/locale/uk'
import pt from 'vuetify/es5/locale/pt'
import es from 'vuetify/es5/locale/es'
import cn from 'vuetify/es5/locale/zh-Hant'

import { lightThemeTokens } from '@/plugins/colors'


Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#B645EE",
        secondary: "#03A9F4",
        ...lightThemeTokens
      },
    },
  },
  lang: {
    locales: { en, ru, cn, ua, pt, es },
    current: localStorage.getItem('i18nLang') || 'en'
  }
});

